import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {
  EquipmentType,
  PaginatedContract,
  ShipmentMode,
  ContractStatusEnum,
  StopLocation
} from '@shipwell/backend-core-singlerequestparam-sdk';
import {CONTRACTS_QUERY_KEY} from 'App/data-hooks/queryKeys';
import {getContracts} from 'App/api/contracts/typed';

export const MAX_AMOUNT_OF_CONTRACTS_TO_DISPLAY = 100;

export type PricingIntelFormValues = {
  equipmentType?: EquipmentType;
  mode?: ShipmentMode;
  stops?: Array<Pick<StopLocation, 'address'>>;
};

export const useGetPIContracts = ({
  equipmentType,
  stops,
  pageSize,
  options,
  status = ContractStatusEnum.Active
}: {
  equipmentType?: EquipmentType;
  stops?: Array<Pick<StopLocation, 'address'>>;
  pageSize: number;
  options?: UseQueryOptions<PaginatedContract>;
  status?: ContractStatusEnum;
}) => {
  const origin = stops?.[0];
  const destination = stops?.[1];
  return useQuery(
    [CONTRACTS_QUERY_KEY, equipmentType?.machine_readable] as QueryKey,
    async () => {
      const response = await getContracts({
        modes: ['FTL'],
        pageSize: pageSize,
        equipmentTypes: equipmentType?.machine_readable ? [equipmentType?.machine_readable] : [],
        status,
        ...(origin && {
          originsContains: [
            origin.address?.formatted_address || '',
            origin.address?.postal_code || '',
            origin.address?.postal_code?.slice(0, 3) || '',
            origin.address?.city || ''
          ].filter(Boolean)
        }),
        ...(destination && {
          destinationsContains: [
            destination.address?.formatted_address || '',
            destination.address?.postal_code || '',
            destination.address?.postal_code?.slice(0, 3) || '',
            destination.address?.city || ''
          ].filter(Boolean)
        })
      });
      return response;
    },
    {
      ...options
    }
  );
};
